export default {
  app: {
    title: '跌倒检测系统',
    titleShort: '跌倒检测',
  },
  canvas: {
    origin: 'O',
    axisX: 'X (m)',
    axisY: 'Y (m)',
  },
  nav: {
    trackMonitor: '告警监控',
    activityOverview: '活动概览',
    roomLayout: '房间布局',
    activityShort: '概览',
    roomShort: '房间',
    paramConfig: '参数配置',
    track: '告警',
    connect: '连接',
    config: '配置',
  },
  install: {
    mode: '安装方式:',
    top: '顶装',
    side: '侧装',
  },
  track: {
    visualization: '告警地图',
    showTrackId: '显示轨迹ID',
    resetViewTitle: '重置视图（拖拽平移、滚轮缩放）',
    resetViewTitleShort: '重置视图',
    reset: '重置',
    count: '人数',
    deviceOnlineShort: '设备{state}',
    online: '在线',
    offline: '离线',
    checking: '查询中',
    trackIdOnOff: '轨迹ID {state}',
    on: '开',
    off: '关',
    poseStand: '站立',
    poseWalk: '行走',
    poseSit: '坐',
    poseLie: '躺',
    poseUnknown: '未知',
    logToggle: '显示/隐藏日志',
    sidebarToggle: '显示/隐藏侧栏',
  },
  connection: {
    mqttTitle: 'MQTT 连接配置',
    deviceMac: '设备序列号',
    deviceMacColon: '设备序列号',
    subscribeTopic: '订阅主题',
    subscribeTopicColon: '订阅主题:',
    configTopicColon: '配置主题:',
    topicPlaceholder: 'radar/falldetect/Dxxxxxxxxxxxxxxxxxxx/report',
    configTopicPlaceholder: 'radar/falldetect/Dxxxxxxxxxxxxxxxxxxx/cmd',
    connect: '连接',
    disconnect: '断开',
    connecting: '连接中...',
    connectingShort: '连接中',
  },
  common: {
    custom: '自定义',
    dash: '-',
  },
  status: {
    title: '连接状态',
    connected: '已连接',
    disconnected: '未连接',
    appServerConnected: 'APP已连接服务器',
    appServerDisconnected: 'APP未连接服务器',
    appServerConnecting: 'APP正在连接服务器…',
    appServerConnectedShort: 'APP已连服务器',
    appServerDisconnectedShort: 'APP未连服务器',
    appServerConnectingShort: 'APP连接中…',
    deviceOnline: '设备在线:',
    deviceOnlineLabel: '设备在线',
    deviceOfflineLabel: '设备离线',
    deviceChecking: '正在查询',
    hardwareVersion: '硬件版本号:',
    refreshHwVersion: '刷新硬件版本',
    writeHwVersionTest: '写硬件版本(测试)',
    hwVersionInputPlaceholder: '如 v0.1.2.3',
    online: '在线',
    offline: '离线',
    framesReceived: '接收帧数:',
    frameSeq: '帧序号:',
    framesLine: '接收帧数 {frames} · 帧序号 {seq}',
    personCount: '当前人数',
  },
  config: {
    title: '参数配置',
    configTopic: '配置主题',
    algoParams: '算法配置参数',
    algoParamsShort: '算法参数',
    radarHeight: '雷达高度 (m):',
    downtAngle: '下倾角 (度):',
    downtPresetSide: '侧装 30°',
    downtPresetTop: '顶装 90°',
    downtCustomHint: '也可手填其他角度',
    radarRoll: '雷达横滚角 (度):',
    radarAzimuth: '雷达方位角 (度):',
    zFallMax: '跌倒高度门限 (m):',
    fallAlarmWaitS: '判断时间 (s):',
    microAccumMaxCnt: '微动累积 (帧):',
    heightShort: '高度(m)',
    downtShort: '下倾角(°)',
    rollShort: '横滚角(°)',
    azimuthShort: '方位角(°)',
    zFallMaxShort: '跌倒门限(m)',
    fallAlarmWaitSShort: '判断时间(s)',
    microAccumMaxCntShort: '微动累积(帧)',
    otherParams: '其他',
    collapseOther: '收起',
    reportFormat: '数据输出格式:',
    reportFormatShort: '数据输出格式',
    dataOutputFormat: '数据输出格式:',
    dataOutputFormatShort: '数据输出格式',
    applyReportFormat: '应用格式',
    reportFormatCaution: '请谨慎修改：切换后轨迹/告警的数据输出形态会改变。选好后点「设置参数」下发，点「获取参数」可同步设备当前值。本页改参仍走二进制命令，并同时兼容 TLV 与 JSON 接收。',
    dataOutputFormatCaution: '请谨慎修改：切换后轨迹/告警的数据输出形态会改变。选好后点「设置参数」下发，点「获取参数」可同步设备当前值。',
    reportFormatNeedVersion: '当前固件低于 {need}，不支持切换数据输出格式',
    dataOutputFormatNeedVersion: '当前固件低于 {need}，不支持切换数据输出格式',
    dataOutputFormatCurrent: '当前：{format}',
    sceneMode: '场景模式:',
    sceneModeShort: '场景模式',
    sceneModeGeneral: '通用',
    sceneModeShower: '淋浴间',
    sceneModeCurrent: '当前：{scene}',
    sceneModeCaution: '请谨慎修改：切换后算法场景会改变（淋浴间使用专用建轨/确认门）。选好后点「设置参数」下发，点「获取参数」可同步设备当前值。',
    sceneModeNeedVersion: '当前固件低于 {need}，不支持切换场景',
    outputOn: '开',
    outputOff: '关',
    trackOutput: '轨迹输出:',
    trackOutputShort: '轨迹输出',
    trackOutputCurrent: '当前：{state}',
    trackOutputCaution: '请谨慎修改：关闭后设备停止上报轨迹帧，仅保留跌倒/功能区告警。选好后点「设置参数」下发，点「获取参数」可同步设备当前值。',
    trackOutputNeedVersion: '当前固件低于 {need}，不支持切换轨迹输出',
    alarmOutput: '告警输出:',
    alarmOutputShort: '告警输出',
    alarmOutputCurrent: '当前：{state}',
    alarmOutputCaution: '请谨慎修改：关闭后设备停止上报跌倒/功能区告警帧，仅保留轨迹。选好后点「设置参数」下发，点「获取参数」可同步设备当前值。',
    alarmOutputNeedVersion: '当前固件低于 {need}，不支持切换告警输出',
    meter: '米',
    degree: '度',
    frameUnit: '帧',
    secondUnit: '秒',
    startSession: '开始会话',
    endSession: '结束会话',
    getParams: '获取参数',
    setParams: '设置参数',
    getParamsGetting: '获取中…',
    getParamsSuccess: '已更新',
    getParamsFail: '获取失败',
    setParamsSetting: '设置中…',
    setParamsSuccess: '设置成功',
    setParamsFail: '更新失败',
    paramsNeedConnect: '请先连接 MQTT 后再配置参数',
    paramsNeedFetch: '尚未从设备获取参数，请先点「获取参数」',
    getDebugParams: '获取DEBUG参数',
    setDebugParams: '设置DEBUG参数',
    sessionStatus: '会话状态:',
    sessionStarted: '已开始',
    sessionNotStarted: '未开始',
    sessionLabel: '会话:',
    lastOperation: '最后操作:',
    responseTitle: '配置日志',
    showLogPanel: '查看日志',
    hideLogPanel: '收起日志',
    clearLogs: '清空日志',
    clear: '清空',
    versionUpgradeTitle: '版本与升级',
    deviceVersion: '当前版本',
    latestVersion: '最新版本',
    upgradeProgress: '升级进度',
    checkUpdate: '检查更新',
    upgradeNow: '开始升级',
  },
  upgrade: {
    noVersion: '无版本号',
    noVersionHint: '未读取到有效设备版本号，不支持升级',
    serverVersion: '服务器版本',
    checking: '正在检查更新…',
    readingVersion: '正在读取设备版本…',
    deviceVersionOk: '设备版本: {version}',
    serverVersionOk: '服务器版本: {version}',
    readVersionFailed: '读取设备版本失败: {message}',
    errDeviceOffline: '设备离线：30秒内未收到 live/report，请确认在线后重试',
    errUnsupportedDeviceType: '仅支持 D 开头的跌倒检测序列号',
    errBadServerVersion: '服务器版本格式异常: {name}',
    resultNeedUpdate: '需要升级',
    resultUpToDate: '已是最新版本',
    resultNoServer: '云端暂无升级版本',
    noServerVersion: '无可用版本',
    compareLog: '设备 {device} / 服务器 {server}',
    checkFailed: '检查更新失败: {message}',
    cannotUpgradeNoVersion: '设备无有效版本号，不支持升级',
    cannotUpgrade: '当前不可升级（请先检查更新并确认设备在线）',
    noHwVersion: '未读取',
    readingHwVersion: '正在读取硬件版本…',
    deviceHwVersionOk: '硬件版本: {version}',
    readHwVersionFailed: '读取硬件版本失败: {message}',
    errBadHwVersion: '硬件版本格式错误: {name}',
    err4gNotSupported: '当前为 4G 版设备，暂不支持通过页面升级',
    errWifiSerialRequired: '仅 WiFi 版设备支持页面升级（序列号第 3 位为 W）',
    errInvalidSerialForUpgrade: '序列号须为 20 位且为 WiFi 版方可页面升级',
    tryResume: '断点续传（中断后可从上次进度恢复）',
    phaseDownload: '下载',
    phaseFlash: 'Flash',
    phaseJump: '正在重启设备…',
    phaseVersion: '版本写入',
    serverFirmwareFile: '云端固件: {suffix}（{url}）',
    serverFirmwareBadSuffix: '云端固件 URL 后缀非 .hex/.bin: {url}',
    firmwareParsed: '固件校验通过: {desc}',
    starting: '开始固件升级…',
    success: '升级完成，设备版本: {version}',
    failed: '升级失败: {message}',
    failedStage: '升级失败阶段: {stage}',
    failedStageDetail: '升级失败阶段: {stage}（{detail}）',
    phaseHttpDownload: '正在从服务器下载固件…',
    phaseIapUpload: '正在通过 MQTT 上传固件到设备…',
    phaseWaitLive: 'Flash 完成，等待设备重新上线…',
    errNoLiveAfterCommit: 'COMMIT 成功但未收到新的 live 心跳',
    liveOkStartVersion: '[V2] 设备已上线，开始写入版本号',
    opCheckUpdate: '检查更新',
    opReadVersion: '读取设备版本',
    opUpgradeDone: '固件升级',
  },
  history: {
    title: '告警历史',
    titleShort: '历史',
    show: '显示历史',
    hide: '隐藏历史',
    close: '关闭历史',
    clear: '清空历史',
    empty: '暂无告警',
  },
  activity: {
    statusTitle: '活动状态',
    statusActive: '有活动',
    statusInactive: '暂无活动',
    statusAbsent: '无人',
    statusPaused: '无人',
    statusHint: '有轨迹显示有活动；无轨迹立即显示暂无活动；连续无轨迹超过设定时长显示无人',
    timeoutLabel: '无人判定',
    timeoutUnit: '分钟',
    position: '位置',
    noFallAlert: '当前无跌倒告警',
    roomPreview: '房间示意',
    roomPreview3d: '房间空间图',
    view3d: '3D',
    view2d: '2D',
    view3dHint: '拖拽旋转 · 滚轮缩放 · 蓝点=雷达（按安装高度）',
    view3dLoadFail: '3D 资源加载失败。请确认已部署完整 dist/assets（含 RoomSpace3DCanvas-*.js），或使用 VITE_BASE=/ 重新构建后上传',
    view3dRetry: '重试加载',
    posCenter: '房间中部',
    posFront: '房间前部',
    posBack: '房间后部',
    posLeft: '房间左侧',
    posRight: '房间右侧',
    posFrontLeft: '左前',
    posFrontRight: '右前',
    posBackLeft: '左后',
    posBackRight: '右后',
  },
  room: {
    title: '房间与雷达布局',
    nameLabel: '房间名称',
    namePlaceholder: '例如：主卧、客厅',
    width: '房间宽度',
    depth: '房间深度',
    radarX: '雷达 X',
    radarY: '雷达 Y',
    dragHint: '拖拽手柄调整房间尺寸与雷达位置；拖雷达前方旋转柄可调方位角（与配置页同步）；点击功能区可移动或缩放',
    layoutReadout: '宽 {width} m × 深 {depth} m · 雷达 X {radarX} / Y {radarY} m',
    azimuthReadout: '方位角 {azimuth}°',
    installFromDevice: '安装方式：{mode}（来自设备参数）',
    saveLayout: '保存',
    zonesEmptyShort: '暂无功能区',
    zonesTitle: '功能区',
    zonesHint: '点击画布中的矩形选中；拖拽移动，拖角点缩放；类型与启用可在下方编辑',
    zonesEmpty: '暂无功能区，点击「添加功能区」创建',
    addZone: '添加功能区',
    removeZone: '删除选中',
    loadParams: '从设备加载',
    loadParamsGetting: '加载中…',
    loadParamsSuccess: '已更新',
    loadParamsFail: '加载失败',
    saveLayoutSetting: '保存中…',
    saveLayoutSuccess: '保存成功',
    saveLayoutFail: '保存失败',
    writeZonesToDevice: '保存',
    loadOk: '加载成功',
    loadFail: '加载失败',
    saveOk: '保存成功',
    saveFail: '保存失败',
    funcZonesFwHint: '功能区需固件 v0.1.6.0 及以上',
    funcZonesFwCurrent: '当前 {version}',
    funcZonesFwTooOld: '当前版本 {version} 过低，无法读写功能区',
    zoneType: '类型',
    zoneEnabled: '启用',
    zoneDisabled: '禁用',
    zoneType0: '屏蔽',
    zoneType1: '驻留',
    zoneType2: '入侵',
    zoneType3: '多人',
    zoneType4: '离开',
    zoneType5: '离开房间',
  },
  alarm: {
    title: '跌倒告警',
    zoneTitle: '功能区告警',
    zoneId: '区号',
    type: '告警类型',
    x: 'x',
    y: 'y',
    time: '时间',
    typeFast: '快速摔倒',
    typeSlow: '慢跌倒',
    typeVerySlow: '缓慢跌倒',
    typeUnknown: '未知类型({type})',
  },
  log: {
    sidebarTitle: '日志',
    sidebarTitleShort: '日志',
    clickToCollapse: '点击收起',
    showFrameLogs: '显示帧接收日志',
    clearLogs: '清空日志',
  },
  ack: {
    success: '成功',
    invalid_param: '无效参数',
    invalid_state: '无效状态（需要先开始会话）',
    invalid_length: '无效长度',
    crc_error: 'CRC错误',
    buffer_overflow: '缓冲区溢出',
    decode_error: '解码错误',
    invalid_status: '状态码无效 ({status})',
    unknown_status: '未知状态 ({hex})',
  },
  tlv: {
    headerTooShort: '数据长度不足，无法读取帧头',
    badMagic: '帧头错误，未找到 0xAA 0x55',
    frameTypeTooShort: '数据长度不足，无法读取帧类型',
    frameLenTooShort: '数据长度不足，无法读取帧长度',
    crcTooShort: '数据长度不足，无法读取CRC',
    extDataInsufficient: '扩展数据长度不足: 剩余={remaining}',
    base64Failed: 'Base64解码失败: {message}',
    unsupportedFormat: '不支持的消息格式',
    unknown: '未知原因',
  },
  msg: {
    parseFrameFailed: '解析帧数据失败: {reason}',
    previewPart: ' 数据预览: {preview}',
    handleError: '处理消息错误: {message}',
    errNeedConnectionInfo: '错误: 请填写完整的连接信息',
    clientId: '使用客户端ID: {id}',
    connectingBroker: '正在连接 MQTT Broker: {url}...',
    mqttConnected: 'MQTT 连接成功',
    subscribeTopicFailed: '订阅主题失败: {message}',
    subscribedTopic: '已订阅主题: {topic}',
    subscribeLiveFailed: '订阅在线主题失败: {message}',
    subscribedLive: '已订阅在线主题: {topic}',
    mqttError: 'MQTT 错误: {message}',
    reconnecting: '正在重新连接...',
    reconnectSkipAutoFetch: '已重新连上服务器，跳过自动读取参数（可手动点获取参数）',
    forceReconnect: '检测到链路异常，正在重新连接服务器（{reason}）',
    connectFailed: '连接失败: {message}',
    disconnected: '已断开 MQTT 连接',
  },
  cfg: {
    decodeFailed: '配置响应解码失败',
    unsupportedFormat: '不支持的配置响应格式',
    parseResponseFailed: '解析配置响应失败: {hex}',
    receivedConfigHex: '收到配置响应数据: {hex}',
    ackReceived: '收到ACK响应: 原始命令={cmd}, 状态={status}',
    sessionStarted: '会话已开始',
    sessionEnded: '会话已结束',
    getParamsOk:
      '获取参数成功: 高度={h}m, 下倾角={d}°, 横滚角={r}°, 方位角={a}°, 跌倒门限={z}m, 判断时间={w}s, 微动累积={m}帧',
    setParamsOk:
      '参数设置成功: 高度={h}m, 下倾角={d}°, 横滚角={r}°, 方位角={a}°, 跌倒门限={z}m, 判断时间={w}s, 微动累积={m}帧',
    sendingGetAllParams: '正在获取算法参数与微动累积...',
    sendingSetAllParams:
      '正在设置参数: 高度={h}m, 下倾角={d}°, 横滚角={r}°, 方位角={a}°, 跌倒门限={z}m, 判断时间={w}s, 微动累积={m}帧',
    fallAlarmWaitWriteSkipLegacy: '当前固件为旧版算法块(20字节)，判断时间未写入',
    fallAlarmWaitRetryLegacy: '24字节算法块被拒绝，改用旧版20字节重试',
    sendingGetFuncZones: '正在读取功能区配置…',
    sendingSetFuncZones: '正在下发功能区配置…',
    getFuncZonesOk: '功能区读取成功：{count} 个区',
    getFuncZonesEmptyKeepLocal: '设备返回空功能区，保留当前 {count} 个区（可能均为未使能）',
    setFuncZonesOk: '功能区下发成功：{count} 个区',
    getFuncZonesFailed: '功能区读取失败',
    setFuncZonesFailed: '功能区下发失败',
    getFuncZonesParseFail: '功能区应答解析失败',
    buildGetFuncZonesFail: '构建功能区读取命令失败',
    buildSetFuncZonesFail: '构建功能区下发命令失败',
    roomConfigSkippedLowVersion: '固件版本 {version} 低于 {need}，跳过房间参数同步',
    buildSetRoomConfigFail: '构建设置房间参数命令失败',
    sendingSetRoomConfig: '正在下发房间尺寸/雷达位…',
    setRoomConfigOk: '房间尺寸/雷达位下发成功',
    buildGetRoomConfigFail: '构建读取房间参数命令失败',
    getRoomConfigParseFail: '房间参数应答解析失败',
    getRoomConfigOk: '房间参数读取成功：宽 {w} m × 深 {d} m',
    funcZonesSkippedLowVersion: '固件版本 {version} 低于 {need}，跳过功能区同步',
    reportFormatSkippedLowVersion: '固件版本 {version} 低于 {need}，无法切换输出格式',
    buildGetReportFormatFail: '构建读取输出格式命令失败',
    buildSetReportFormatFail: '构建设置输出格式命令失败',
    sendingSetReportFormat: '正在下发输出格式…',
    reportFormatApplied: '输出格式已切换为 {format}',
    setReportFormatFailed: '设置输出格式失败',
    buildGetSceneModeFail: '构建场景模式读取命令失败',
    buildSetSceneModeFail: '构建场景模式下发命令失败',
    sendingSetSceneMode: '正在下发场景模式…',
    sceneModeApplied: '场景模式已切换为 {scene}',
    buildGetTrackOutputFail: '构建轨迹输出读取命令失败',
    trackOutputApplied: '轨迹输出已切换为 {state}',
    buildGetAlarmOutputFail: '构建告警输出读取命令失败',
    alarmOutputApplied: '告警输出已切换为 {state}',
    funcZonesTruncated: '功能区超过 {max} 个，仅下发前 {max} 个',
    funcZonesMaxReached: '功能区最多 {max} 个',
    getDebugOk: '获取DEBUG参数成功',
    getDebugFailed: '获取DEBUG参数失败',
    getDebugParseFail: 'DEBUG参数应答解析失败',
    getMicroAccumOk: '读取微动累积: {value} 帧',
    getMicroAccumLegacy: '设备为旧版DEBUG块(12字节)，无微动累积字段',
    setDebugOk: 'DEBUG参数设置成功',
    setDebugFailed: 'DEBUG参数设置失败',
    sendingSetHwVersion: '正在写入硬件版本号…',
    setHwVersionOk: '硬件版本写入成功: {version}',
    setHwVersionFailed: '硬件版本写入失败: {message}',
    sendingMicroAccum: '发送微动累积设置: {value} 帧',
    setMicroAccumOk: '微动累积设置成功: {value} 帧',
    setMicroAccumFailed: '微动累积设置失败: {value} 帧',
    microAccumWriteSkipLegacy: '当前固件不支持微动累积(12字节DEBUG块)，该值未写入',
    microAccumRetryLegacy: '16字节DEBUG设置被拒，尝试旧版12字节块(不含微动累积)',
    sendingSetDebugLegacy: '发送旧版DEBUG设置(不含微动累积)',
    setParamsRetrySession: '设置失败，自动开始会话后重试一次...',
    sessionStartFailBusy: '会话开始失败：设备可能已在会话中，请先结束会话',
    opNeedSessionFirst: '操作失败：需要先开始会话',
    handleConfigError: '处理配置响应错误: {message}',
    configWillReceiveOn: '配置响应将从轨迹主题和配置主题接收: {topic}, {configTopic}',
    subscribeConfigFailed: '订阅配置主题失败: {message}',
    subscribedConfig: '已订阅配置主题: {topic}',
    errMqttNotConnected: '错误: MQTT未连接',
    errConfigTopicEmpty: '错误: 配置主题未设置',
    sendConfigFailed: '发送配置命令失败: {message}',
    errFillBrokerFirst: '错误: 请先在连接页填写 Broker 地址并选择/填写订阅主题',
    connectingThenSessionStart: '正在连接 MQTT，连接成功后将自动发送会话开始命令...',
    deviceOfflineNeedWait: '设备未在线，请等待设备心跳后再操作',
    deviceOfflineSkipAutoFetch: '设备未在线，跳过自动读取参数（设备上线后可手动获取）',
    buildSessionStartFail: '构建会话开始命令失败',
    sendingSessionStart: '发送会话开始命令...',
    buildSessionEndFail: '构建会话结束命令失败',
    sendingSessionEnd: '发送会话结束命令...',
    sessionEndWarn: '结束会话失败（可能网络抖动），不影响已保存/读取的参数',
    buildGetParamsFail: '构建获取参数命令失败',
    sendingGetParams: '发送获取参数命令...',
    errInvalidParams: '错误: 参数值无效',
    buildSetParamsFail: '构建设置参数命令失败',
    sendingSetParams:
      '发送设置参数命令: 高度={h}m, 下倾角={d}°, 横滚角={r}°, 方位角={a}°, 跌倒门限={z}m, 微动累积={m}帧',
    buildGetDebugFail: '构建获取DEBUG参数命令失败',
    sendingGetDebug: '发送获取DEBUG参数命令...',
    errInvalidDebug: '错误: DEBUG参数值无效',
    buildSetDebugFail: '构建设置DEBUG参数命令失败',
    sendingSetDebug: '发送设置DEBUG参数命令',
    responseTimeout: '配置命令超时: {cmd}',
    configAutoRetry: '配置命令响应超时，自动重试第 {attempt}/{max} 次...',
    paramsWriteWarn: '算法参数下发失败，但功能区已保存成功',
    roomConfigWriteWarn: '房间尺寸/雷达位下发失败，但功能区已保存成功',
  },
}
